import React from 'react';
import { NextPage } from 'next';
import PrevJoin from 'components/auth/_login_ask_to_join';

const Login_ask_to_join: NextPage = () => {
  return <PrevJoin />;
};

export default Login_ask_to_join;
